// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uN1Um","subtitle":"styles_subtitle__nNfQI","paragraph":"styles_paragraph__NcA-X"};